const moduleoptions = {
	title: "Modul valg",
	new_moduleoption: "Nytt modul valg",
	edit_moduleoption: "Rediger: {name}",
	id: "ID",
	moduletemplate_id: "Modulmal",
	coursetemplate_id: "Kursmal",
	name: "Navn",
	price: "Pris",
	enrol_select: "Velg ved påmelding",
	hours: "Tid(timer)",
	comment: "Kommentar",
	mandatory_accomplishment: "Obligatorisk å fullføre",
	enrol_select_disable: "Skjul I påmelding er valgt for modul. Dette valget er ikke tilgjengelig. Modul må være synlig i påmelding.",
	accomp_select_disable: "Skjul I progresjon er valgt for modul. Dette valget er ikke tilgjengelig. Modul må være synlig i progresjon.",
};
export default moduleoptions;